export const SELECTION_KEYS = ['Enter', 'Space'];
